<template>
    <div class="result-bar__sort">
        <select-field :options="sortOptions" v-model="selectedSortOption" icon-type="sort"></select-field>
    </div>
</template>

<script>
import SelectField from './selector.vue';
import { trackEvent } from '../tracker';

export default {
    data() {
        return {
            selectedSortOption: 'price_lowest',
            translations: APP_CONFIG.TRANSLATION.SEARCH_SORT,
        }
    },
    mounted() {
        this.setSortOption();
    },
    methods: {
        setSortOption() {
            let setSort = this.$route.query.sortBy || 'price';
            switch(setSort) {
                case 'reviewScore':
                    this.selectedSortOption = 'smiley_highest';
                    break;
                default:
                    this.selectedSortOption = 'price_lowest';
                    break;
            }
        }
    },
    watch: {
        '$route.query'() {
            this.setSortOption();
        },
        selectedSortOption() {
            let query = Object.assign({}, this.$route.query);
            switch(this.selectedSortOption) {
                case 'price_lowest':
                    query.sortBy = 'price';
                    query.sortOrder = 'asc';
                    break;
                case 'smiley_highest':
                    query.sortBy = 'reviewScore';
                    query.sortOrder = 'desc';
                    break;
                default:
                    return;
            }

            this.$router.replace({query}, (to) => {
                trackEvent({
                    event: 'Filter - Brugerbedømmelser',
                    target: to.fullPath,
                    value: this.selectedSortOption,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
            this.$emit('sortchange');
        }
    },
    computed: {
        sortOptions() {
            if(typeof this.translations.options !== 'object') {
                return [ ];
            }

            let options = [ ];
            for(let i in this.translations.options) {
                options.push({
                    text: this.translations.options[i],
                    value: i
                });
            }

            return options;
        }
    },
    components: {
        SelectField
    }
}
</script>

